import React from 'react';
import { Box, Typography } from '@mui/material';
import { styles } from './data-zone-selector-helper';

interface SdzSelectorHeadingProps {
    zonesLoading?: boolean;
    isSecureDataZoneEmpty?: boolean;
}

export const SdzSelectorHeading = ({
    zonesLoading,
    isSecureDataZoneEmpty,
}: SdzSelectorHeadingProps): React.JSX.Element => {
    return (
        <Box
            sx={{
                margin: isSecureDataZoneEmpty ? '47px 0 58px 0' : '32px 0 0 0',
            }}
            className='sdz-heading'
        >
            <Typography variant='h1' sx={styles.sdzHeading}>
                Secure Data Zones
            </Typography>
            {!zonesLoading && isSecureDataZoneEmpty ? (
                <Typography variant='caption' sx={styles.sdzHeadingtext}>
                    You do not have access to any Secure Data Zones.
                    <br />
                    Contact your administrator for access or try a different
                    <br />
                    username and password.
                </Typography>
            ) : (
                <Typography variant='caption' sx={styles.sdzHeadingtext}>
                    Choose the environment you would
                    <br />
                    like to view.
                </Typography>
            )}
        </Box>
    );
};
